import { render, staticRenderFns } from "./qcOrderList2022.vue?vue&type=template&id=4a1d9fb3&scoped=true&"
import script from "./qcOrderList2022.vue?vue&type=script&lang=js&"
export * from "./qcOrderList2022.vue?vue&type=script&lang=js&"
import style0 from "./qcOrderList2022.vue?vue&type=style&index=0&id=4a1d9fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d9fb3",
  null
  
)

export default component.exports